import * as arrow from "apache-arrow";
import {
   getECLToken,
   sourceOneRestURL,
   sourceOneRESTFetchConfig,
} from "./fetchVariables";

//For parquet reading
// import readParquetToJSON from "./DuckDB/readParquetToJSON";
// import { v4 } from "uuid"

export default async function endpointRequest(
   objectID,
   blockID,
   sessionID,
   endpoint,
   format = "arrow_ipc",
) {
   const accessToken = await getECLToken();
   const request = await fetch(sourceOneRestURL, {
      ...sourceOneRESTFetchConfig(accessToken),
      body: JSON.stringify({
         query_type: "app_endpoint",
         object: objectID,
         format: format,
         block_id: blockID,
         endpoint: endpoint,
         session_id: sessionID,
      }),
   });

   if (request.status >= 400) {
      const error = await request.json();
      throw new Error(`${error.error_description}`);
   }

   let jsTable;

   switch (format) {
      // case "parquet":
      //     DuckDB from parquet
      //     jsTable = await readParquetToJSON(v4(), request)
      case "csv":
         //Do a csv
         break;
      default: {
         // Wrapped "default" case inside of braces to remove ESLint error no-case-declarations.
         //Do an arrow IPC
         const table = await arrow.tableFromIPC(request);
         const columnData = table.schema.fields.map((c, i) =>
            table.getChildAt(i).toJSON(),
         );
         let rowData = [];
         for (let i = 0; i < table.numRows; i++) {
            let row = table.schema.fields.map((c, ind) => {
               let rowVal;
               if (
                  columnData[ind][i] === null ||
                  columnData[ind][i] === undefined
               ) {
                  //Early Escape is null
                  rowVal = null;
                  return rowVal;
               }
               switch (
                  c.type.typeId //Otherwise cast to fitting type for convenience
               ) {
                  case arrow.Type.Int:
                  case arrow.Type.Int8:
                  case arrow.Type.Int16:
                  case arrow.Type.Int32:
                  case arrow.Type.Int64:
                  case arrow.Type.Decimal:
                  case arrow.Type.Float:
                  case arrow.Type.Float16:
                  case arrow.Type.Float32:
                  case arrow.Type.Float64:
                     rowVal = Number(columnData[ind][i]);
                     break;
                  case arrow.Type.Date:
                  case arrow.Type.Time:
                  case arrow.Type.Timestamp:
                  case arrow.Type.DateMillisecond:
                     rowVal = new Date(columnData[ind][i]);
                     break;
                  default:
                     rowVal = columnData[ind][i];
               }
               return rowVal;
            });
            rowData.push(row);
         }
         jsTable = {
            columns: table.schema.fields,
            rows: rowData,
         };
      }
   }
   return jsTable;
}
